import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ["StatusChangeButton", "StatusInputContainer"]

  connect() {
    this.id = this.element.dataset.id
  }

  onStatusChangeClick(e) {
    this.StatusChangeButtonTarget.classList.add("hidden")
    this.StatusInputContainerTarget.classList.remove("hidden")
  }

  onStatusChange(e) {
    e.target.form.requestSubmit()
  }

}